import React from "react";
import { Badge } from "@mui/material";
import "../chip/ChipRenderer.js";
import { ChipVariant, ChipType } from "../chip/types.js";
import { Chip } from "../chip/Chips.js";
import "../chip/ListWithChipTooltip.js";
import "../chip/SquaredChipList.js";
import "../icons/Icon.js";
import "../icons/ExpandMoreIcon.js";
import { useAutocompleteChipClasses } from "./AutocompleteChip.styles.js";
const AutocompleteChip = ({ badgeContent, ...otherProps }) => {
  const { classes } = useAutocompleteChipClasses();
  const chipProps = {
    icon: badgeContent ? /* @__PURE__ */ React.createElement(Badge, { className: classes.autocompleteChipPreviouslyAssignedItemBadge, badgeContent, color: "default" }) : null
  };
  return /* @__PURE__ */ React.createElement(
    Chip,
    {
      className: classes.autocompleteChipPreviouslyAssignedItemChip,
      fillWidth: false,
      chipType: ChipType.TagMarkIcon,
      chipVariant: ChipVariant.DefaultReversed,
      ...chipProps,
      ...otherProps
    }
  );
};
const renderTags = (value, getTagProps, getOptionLabel) => {
  return value?.map((option, index) => {
    const optionLabel = getOptionLabel(option);
    return optionLabel ? /* @__PURE__ */ React.createElement(AutocompleteChip, { label: optionLabel, badgeContent: option?.badgeContent, ...getTagProps({ index }), key: option.value }) : null;
  }).filter((v) => v);
};
export {
  AutocompleteChip,
  renderTags
};
//# sourceMappingURL=AutocompleteChip.js.map
